require('./stroke-analysis.jade')

StrokeAnalysisDirective = (StrokeAnalysisService) ->
  createChartOptions = (data, element) ->
    chart:
      renderTo: element[0]
      type: 'pie'
      backgroundColor: 'transparent'
    plotOptions:
      pie:
        borderWidth: 0
        shadow: false
        startAngle: -90
        endAngle: 90
        center: ['50%', '50%']
        enableMouseTracking: false
        dataLabels:
          enabled: false
    tooltip:
      enabled: false
    title:
      floating: true
      y: 28
      text: ''
    credits:
      enabled: false
    series:[
      {
        size: '100%'
        innerSize: '92%'
        data: [
          {
            color:'#006A68'
            y: data.par5.y1
          }
          {
            color:'#B3CECE'
            y: data.par5.y2
          }
        ]
      }
      {
        size: '92%'
        innerSize: '84%'
        data: [
          {
            color:'#008886'
            y: data.par4.y1
          }
          {
            color:'#B1D4D3'
            y: data.par4.y2
          }
        ]
      }
      {
        size: '84%'
        innerSize: '82%'
        data: [
          {
            color:'#00B8B5'
            y: data.par3.y1
          }
          {
            color:'#B9DEDD'
            y: data.par3.y2
          }
        ]
      }
    ]

  restrict: "A"
  replace: false
  templateUrl: "analysis-charts/stroke-analysis/stroke-analysis.jade"
  scope:
    strokeData: '=strokeData'
  link: (scope, element) ->
    target = element.find(".stroke-chart")
    scope.$watch (-> scope.strokeData), ->
      strokeData = StrokeAnalysisService.convertStrokeDataForChart(scope.strokeData)
      new Highcharts.Chart createChartOptions(strokeData, target)

StrokeAnalysisDirective.$inject = [
  'StrokeAnalysisService'
]

module.exports = StrokeAnalysisDirective



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/analysis-charts/stroke-analysis/stroke-analysis-directive.coffee